<h1 mat-dialog-title>Excel importieren</h1>

<div mat-dialog-content>
    <div class="one-row">
        <input type="file" style="display: none" #fileSelector (change)="handleFile($event)" accept=".xls, .xlsx" />
        <h3>Spalten auswählen</h3>
        <button
            [disabled]="!fileSelectionEnabled"
            mat-stroked-button
            color="accent"
            (click)="openFileSelector()"
            style="margin-right: auto; margin-left: 24px"
        >
            <mat-icon>attach_file</mat-icon>
            Dateien ausw&auml;hlen
        </button>
        <div *ngIf="file">
            <mat-icon style="color: gray">description</mat-icon>
            <span>{{ file.name }}</span>
        </div>
    </div>
    <div class="one-row">
        <div style="width: 100%">
            <mat-form-field style="width: 100%">
                <mat-label>Bezeichnung</mat-label>
                <mat-select [(value)]="bezeichnungColumn">
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Preis</mat-label>
                <mat-select [(value)]="preisColumn">
                    <mat-option [value]="null">Spalte Abwählen</mat-option>
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Mehrwertsteuer</mat-label>
                <mat-select [(value)]="ustColumn">
                    <mat-option [value]="null">Spalte Abwählen</mat-option>
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Kuerzel</mat-label>
                <mat-select [(value)]="kuerzelColumn">
                    <mat-option [value]="null">Spalte Abwählen</mat-option>
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Faktor</mat-label>
                <mat-select [(value)]="faktorColumn">
                    <mat-option [value]="null">Spalte Abwählen</mat-option>
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%">
                <mat-label>Warengruppe</mat-label>
                <mat-select [(value)]="warengruppeColumn">
                    <mat-option [value]="null">Spalte Abwählen</mat-option>
                    <mat-option *ngFor="let column of columnOptions" [value]="column"> Spalte {{ column }} </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>
<div align="end" mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button *kienePermission="[1234]" [disabled]="isDisabled()" (click)="check()" color="primary" mat-flat-button>
        Prüfen
    </button>
</div>
